import React from 'react';

export default function Home() {
    return <div>We're building. Come back later to check out!</div>;
}
